import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class DateShortMaskProcessing extends InputMaskProcessingBase {
  protected fixedPosGroupingChars = [null, null, '/'];
  protected maxLength = 7;

  protected isCharAllowed(pos: number): boolean {
    // TODO: check edge cases like single digit month, double-digit year, position-specific allowed numbers
    return '0123456789'.indexOf(this.processed.value[pos]) > -1;
  }
}
